import { useTranslation } from "react-i18next";
import Layout from "src/components/layout/Layout";
import useAuth from "src/hooks/selectors/useAuth";
import useModules from "src/hooks/selectors/useModules";
import DashboardNetworkCompanyView from "./NetworkCompanyView";
import DashboardNetworkStudentView from "./NetworkStudentView";
import SubscriptionFeatureMiddleware from "src/components/middlewares/SubscriptionFeatureMiddleware";

export default function NetworkView() {
	const { t } = useTranslation("network-view", {
		keyPrefix: "network-view",
	});
	const auth = useAuth();
	const { modules, loading } = useModules();

	if (auth.type === "company" && loading) {
		return <Layout loading title={t(`title-${auth.type}`)}></Layout>;
	}

	if (auth.type === "company" && !modules.includes("student-pool")) {
		return (
			<Layout title={t(`title-${auth.type}`)}>
				<SubscriptionFeatureMiddleware plan="premium" />
			</Layout>
		);
	}
	return (
		<Layout title={t(`title-${auth.type}`)}>
			{auth.type === "student" ? (
				<DashboardNetworkStudentView />
			) : (
				<DashboardNetworkCompanyView />
			)}
		</Layout>
	);
}
